import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { StaggeredMotion, spring } from 'react-motion'

export default class DropChildrenMotion extends Component {
  static propTypes = {
    startTranslateY: PropTypes.number,
    startOpacity: PropTypes.number,
    initialStiffness: PropTypes.number,
    initialDamping: PropTypes.number,
    finalStiffness: PropTypes.number,
    finalDamping: PropTypes.number,
  }

  static defaultProps = {
    startTranslateY: -100,
    startOpacity: 0,
    initialStiffness: 200,
    initialDamping: 25,
    finalStiffness: 500,
    finalDamping: 25,
  }

  render() {
    const {
      children,
      startTranslateY,
      startOpacity,
      initialStiffness,
      initialDamping,
      finalStiffness,
      finalDamping,
    } = this.props

    const defaultStyles = Array(React.Children.count(children))
      .fill()
      .map(_ => ({
        translateY: startTranslateY,
        opacity: startOpacity,
      }))

    const styles = prevInterpolatedStyles =>
      prevInterpolatedStyles.map((_, i) => {
        return i === 0
          ? {
              translateY: spring(0, {
                stiffness: initialStiffness,
                damping: initialDamping,
              }),
              opacity: spring(1, {
                stiffness: initialStiffness,
                damping: initialDamping,
              }),
            }
          : {
              translateY: spring(prevInterpolatedStyles[i - 1].translateY, {
                stiffness: finalStiffness,
                damping: finalDamping,
              }),
              opacity: spring(prevInterpolatedStyles[i - 1].opacity, {
                stiffness: finalStiffness,
                damping: finalDamping,
              }),
            }
      })

    return (
      <StaggeredMotion defaultStyles={defaultStyles} styles={styles}>
        {interpolatingStyles => (
          <div>
            {React.Children.map(
              children,
              (child, i) =>
                child &&
                React.cloneElement(child, {
                  translateY: interpolatingStyles[i].translateY,
                  opacity: interpolatingStyles[i].opacity,
                }),
            )}
          </div>
        )}
      </StaggeredMotion>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DropChildrenMotion.js